import {refreshToken} from '@/api/app.js'

export default function loopRefreshToken() {
  let min10 = 10 * 60 * 1000
  setInterval(() => {
    refreshToken()
  }, min10)
}




// WEBPACK FOOTER //
// ./src/base/refreshToken.js